export default __webpack_public_path__ + "static/media/treinamentos-2.ce2df073.png";